import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ThemeState {
  mode: 'light' | 'dark'
}

// Get initial theme from localStorage or default to light
const getInitialTheme = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('theme')
    return (stored === 'dark' || stored === 'light') ? stored : 'light'
  }
  return 'light'
}

// Apply theme to document
const applyTheme = (mode: 'light' | 'dark') => {
  if (typeof window !== 'undefined') {
    document.documentElement.classList.remove('light-mode', 'dark-mode')
    document.documentElement.classList.add(`${mode}-mode`)
    localStorage.setItem('theme', mode)
  }
}

const initialState: ThemeState = {
  mode: getInitialTheme()
}

// Apply initial theme
applyTheme(initialState.mode)

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
      applyTheme(state.mode)
    },
    setMode: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload
      applyTheme(state.mode)
    }
  }
})

export const { toggleMode, setMode } = themeSlice.actions
export default themeSlice.reducer